export default __webpack_public_path__ + "static/media/titanium-solar-bg.8893cb2f.jpg";